module.exports = __webpack_public_path__ + "static/img/manual_ja_14.d3d6c11.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_14.png
// module id = B4FV
// module chunks = 4